import debounce from 'lodash/debounce';

  // --- Container escaper ---
  // -- To add spacing betweeen

  if ($('.escaper').length > 0) {
    function escaper () {
      $('.escaper').attr('style', '')
      if ($(window).width() >= 768) {
        var escaperMargin = $('.content .container').offset().left
        $('.escaper').each(function(){
          if ($(this).parents('.row').length > 0) {
            escaperMargin += 16
          }
          var escaperWidth = $(this).outerWidth() + escaperMargin
          $(this).outerWidth(escaperWidth).css('max-width', 'none')
          if ($(this).hasClass('escaper-right')) {
            $(this).css('margin-right', -escaperMargin)
          } else if ($(this).hasClass('escaper-left')) {
            $(this).css('margin-left', -escaperMargin)
          }

          // reset
          escaperMargin = $('.content .container').offset().left

          $(this).parents('.section').css('overflow', 'hidden')
        })
      }
    }

    setTimeout(function(){
      escaper()
    }, 100)

    $(window).resize(debounce(

    function(){
      escaper()
    },100))

  }
